<div class="wrapper">
  <h2>
    {{hostel?.name}}
  </h2>

  <div class="description">
    {{getHostelDescription()}}
  </div>
</div>
